import { render, staticRenderFns } from "./EmployeeLeaveAttendance.vue?vue&type=template&id=a8101b06"
import script from "./EmployeeLeaveAttendance.vue?vue&type=script&lang=js"
export * from "./EmployeeLeaveAttendance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports